export default "__VITE_ASSET__QEuOZdXE__"